/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Directory_Detail_Signals_Check_FailedInputs */

const en_directory_detail_signals_check_failed = /** @type {(inputs: Directory_Detail_Signals_Check_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} failed`)
};

const zh_directory_detail_signals_check_failed = /** @type {(inputs: Directory_Detail_Signals_Check_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} 项失败`)
};

/**
* | output |
* | --- |
* | "{count} failed" |
*
* @param {Directory_Detail_Signals_Check_FailedInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_detail_signals_check_failed = /** @type {((inputs: Directory_Detail_Signals_Check_FailedInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Detail_Signals_Check_FailedInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_detail_signals_check_failed(inputs)
	return zh_directory_detail_signals_check_failed(inputs)
});
export { directory_detail_signals_check_failed as "directory.detail.signals.check_failed" }